import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Slider from "react-slick";

import ImageModule from "../../modules/image_module";
import CTABtnModule from "../../modules/cta_btn_module";
import "./Counter.scss";
import "./WhyChoose.scss";
import { Link } from "gatsby";
import { menuLinks } from "../../common/utils/page_url_utils";

const WhyChoose = ({Module}) => {

    var counter_list = Module?.why_choose_module;

    var settings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: 'unslick',
                // settings: {
                //     dots: false,
                //     arrows: true,
                //     slidesToShow: 3,
                //     slidesToScroll: 1,
                // },
            },
            {
                breakpoint: 992,
                settings: 'unslick',
                // settings: {
                //     dots: true,
                //     arrows: true,
                //     slidesToShow: 2,
                //     slidesToScroll: 1,
                // },
            },
            {
                breakpoint: 767,
                settings: 'unslick',
                // settings: {
                //     arrows: false,
                //     dots:true,
                //     slidesToShow: 1,
                //     slidesToScroll: 1,
                // },
            },

        ],
    };
    
    return (
        <section className={`counter why_choose ${Module.why_bg_color} ${Module.why_padd}`}>
            <Container>
                <Row>
                    <Col>
                        <div className="counter-wrapper">
                                
                            {Module?.title && <h2>{Module?.title}</h2>}
                            {Module?.description && <p className={`${counter_list?.length > 0 ? "" : "no_icons"}`}>{Module?.description}</p>}
                            
                            <div className="counter-wrap-inner">
                            {counter_list?.length > 0 && 
                                <Slider {...settings}>
                                    { counter_list?.map((item, index) => {

                                        var page_link = item?.cta_custom_link ? item?.cta_custom_link : item?.cta_menu?.slug ? menuLinks(item?.cta_menu) : "";
                                        return(
                                            <div className={`slider_wrapper ${item?.cta_label ? "" : "no_cta"}`}>
                                                <div className={`counter-wrap`}>
                                                    <div className="counter-box">
                                                        <span className="box">
                                                            {item.upload_icon?.url && <ImageModule ImageSrc={item.upload_icon} altText={item.title} loading="eager" /> }
                                                        </span>
                                                    </div>
                                                    <div className="counter-content">
                                                        {page_link ? 
                                                            <h3><Link to={page_link}>{item.title} <i className="icon-caretright d-md-none" /></Link></h3>
                                                        :
                                                            <h3>{item.title} </h3>
                                                        }                               
                                                        <p>{item.content}</p>

                                                        {item?.cta_label && <CTABtnModule button_cta={{custom_link: item?.cta_custom_link, menu_item: item?.cta_menu, label:  item?.cta_label, theme: "outline"}} /> }
                                                    </div>
                                                </div>
                                            </div>                                    
                                        )})
                                    }
                                </Slider>
                            }
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>

    );
};
export default WhyChoose;
